import Vue from 'vue'
import {options} from './plugins/vuetify'
import App from './App.vue'
import router from './router/index'
import store from './store/index'
import Interceptors from './interceptors/index'
import './registerServiceWorker'

import '@mdi/font/css/materialdesignicons.css'
import './styles/style.css'
import NProgress from 'vue-nprogress'

//
const NPoptions = {
    latencyThreshold: 200, // Number of ms before progressbar starts showing, default: 100,
    router: true, // Show progressbar when navigating routes, default: true
    http: true // Show progressbar when doing Vue.http, default: true
};
Vue.use(NProgress, NPoptions);

import Vuetify from "vuetify";

const vuetify = new Vuetify(options);
//
// Vue.use(VueGoogleMaps, {
//     load: {
//         key: 'AIzaSyCpb54b8FB5WVxBDKAYVknsOZWGYNn0V74',
//         libraries: 'places,directions', // This is required if you use the Autocomplete plugin
//     },
// });

Vue.config.devtools = true
Vue.config.productionTip = false;
Vue.use(Interceptors);

new Vue({
    router,
    store,
    vuetify,
    render: h => h(App)
}).$mount('#app')
